/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Currency } from './Currency';

export type Article = {
    id: string;
    title: string;
    instanceId: string | null;
    type: Article.type;
    amount: number;
    unit: Article.unit;
    pricePerUnit: number;
    price: number;
    currency?: Currency;
}

export namespace Article {

    export enum type {
        BASE = 'BASE',
        OPTION = 'OPTION',
        MATERIAL = 'MATERIAL',
        EXTRAHEIGHT = 'EXTRAHEIGHT',
        OVERHANG = 'OVERHANG',
        FEATURE = 'FEATURE',
    }

    export enum unit {
        PIECES = 'PIECES',
        FOOT = 'FOOT',
        SQUARE_FOOT = 'SQUARE_FOOT',
    }


}
